import { flow, Instance, types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import axios from 'axios';
import { PutCaregiver, PatchCaregiverRecipients, } from '../Services/CaregiverService';
import { IRecipientModelSnapshotIn, Recipient } from '../Models/Recipient';

export const ScoreMember = types.model('ScoreMember', {
  title: types.string,
  icon: types.string,
  iconColor: types.string,
  percentComplete: types.number,
  id: types.string,
  userId: types.string,
});

export const CaregiverStore = types
  .model('CaregiverStore', {
    recipients: types.array(Recipient),
    isLoading: types.maybe(types.boolean),
    partnerCode: types.maybeNull(types.string),
    caregiverId: types.string,
    isAdmin: types.boolean,
  })
  .actions((self) => {
    const wrapLoadingDuringAction = flow(function* (serviceAction: any) {
      self.isLoading = true;
      try {
        yield serviceAction();
      } catch (err) {
        console.error(err);
      }
      self.isLoading = false;
    });

    return {
      saveRecipient: flow(function* (
        userId: string,
        recipient: IRecipientModelSnapshotIn
      ) {
        yield wrapLoadingDuringAction(
          flow(function* () {
            var foundRecipient = self.recipients.find(x => x.id === recipient.id);
            if(foundRecipient) {
              foundRecipient.setFirstName(recipient.firstName);
              foundRecipient.setLastName(recipient.lastName);
              foundRecipient.setGender(recipient.gender);
              foundRecipient.setBirthday(recipient.birthday);
              foundRecipient.setRelationship(recipient.relationship);
              if(recipient.zipCode) foundRecipient.setZipcode(recipient.zipCode);
              if(recipient.notes) foundRecipient.setNotes(recipient.notes);
            } 
            else {
              self.recipients.push(recipient);
            }
            yield PatchCaregiverRecipients(userId, self.recipients);
          })
        );
      }),
      deleteRecipient: flow(function* (
        userId: string,
        recipientId: string | undefined
      ) {
        yield wrapLoadingDuringAction(
          flow(function* () {
            var foundRecipientIndex = self.recipients.findIndex(x => x.id === recipientId);
            if(foundRecipientIndex) {
              self.recipients.splice(foundRecipientIndex,1);
              yield PatchCaregiverRecipients(userId, self.recipients);
            } 
          })
        );
      }),
      savePartnerCodeToCaregiver: flow(function* (
        caregiverId: string,
        groupCode: string
      ) {
        yield wrapLoadingDuringAction(
          flow(function* () {
            let caregiver = {
            caregiverId: caregiverId,
            partnerCode: groupCode,
        }
            yield PutCaregiver(caregiver);
          })
        );
      }),
      loadForCargiverId: flow(function* (caregiverId: string) {
        yield wrapLoadingDuringAction(
          flow(function* () {
            const result = yield axios.get(
              `/caregivers/${caregiverId}/recipients`
            );
            applySnapshot(self, result.data ?? {});
          })
        );
      }),
      saveCaregiver: flow(function* () {
        const caregiver = getSnapshot(self);
        yield wrapLoadingDuringAction(
          flow(function* () {
            yield PutCaregiver(caregiver);
          })
        )
      }),
      setPartnerCode(code: string) {
        self.partnerCode = code;
      },
      logout() {
        self.recipients.clear();
        self.partnerCode = "";
        self.caregiverId = ""
      },
    };
  });


export interface ICaregiverStore extends Instance<typeof CaregiverStore> {
    partnerCode: any;
}
